(function () {
  var CDN = {
    leafletCss: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css',
    leafletJs: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js',
    clusterCss1: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/MarkerCluster.css',
    clusterCss2: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/MarkerCluster.Default.css',
    clusterJs: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/leaflet.markercluster.js'
  };

  function loadCss(href) {
    if (document.querySelector('link[data-sl-href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-sl-href', href);
    document.head.appendChild(link);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-sl-src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') return resolve();
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', reject);
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.setAttribute('data-sl-src', src);
      script.onload = function () { script.dataset.loaded = 'true'; resolve(); };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function initStoreLocator(root) {
    var apiUrl = root.dataset.apiUrl;
    var baseUrl = (root.dataset.baseUrl || '/pages/').replace(/\/?$/, '/');
    var openNewTab = root.dataset.openNewTab === 'true';
    var defaultLat = parseFloat(root.dataset.defaultLat) || 46.6;
    var defaultLng = parseFloat(root.dataset.defaultLng) || 2.3;
    var defaultZoom = parseInt(root.dataset.defaultZoom, 10) || 6;
    // Zoom de départ sur mobile : plus éloigné, car l'écran est étroit (5 = toute la France visible).
    var defaultZoomMobile = parseInt(root.dataset.defaultZoomMobile, 10) || 5;
    var slugOverrides = {};
    try { slugOverrides = JSON.parse(root.dataset.slugOverrides || '{}'); } catch (e) { slugOverrides = {}; }

    var mapEl = root.querySelector('.store-locator__map');
    var listEl = root.querySelector('.store-locator__list');
    var inputEl = root.querySelector('.store-locator__input');
    var searchBtn = root.querySelector('.store-locator__search-btn');
    var geoBtn = root.querySelector('.store-locator__geo-btn');
    var statusEl = root.querySelector('.store-locator__status');

    var map, clusterGroup, userMarker;
    var stores = [];

    // Réglage "Afficher la carte sur mobile" de la section (case à cocher).
    var showMapMobile = root.dataset.showMapMobile === 'true';
    // Même seuil que le @media du CSS (max-width: 749px) : JS et CSS doivent être d'accord
    // sur ce qu'est un "mobile", sinon la carte serait chargée sans être visible (ou l'inverse).
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    // Dernière position recherchée : si la carte démarre après une recherche,
    // on pourra quand même la montrer dessus.
    var lastOrigin = null;

    function slugify(str) {
      return (str || '')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function haversine(lat1, lon1, lat2, lon2) {
      var R = 6371;
      var dLat = (lat2 - lat1) * Math.PI / 180;
      var dLon = (lon2 - lon1) * Math.PI / 180;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    function setStatus(msg) {
      if (statusEl) statusEl.textContent = msg || '';
    }

    function pinIcon() {
      return L.divIcon({
        className: 'store-locator__pin-wrap',
        html: '<span class="store-locator__pin"></span>',
        iconSize: [16, 16],
        iconAnchor: [8, 16],
        popupAnchor: [0, -14]
      });
    }

    function initMap() {
      // Mobile ou non, au moment où la carte démarre : on choisit le zoom de départ correspondant.
      var startZoom = mobileQuery.matches ? defaultZoomMobile : defaultZoom;

      // Zoom minimum = celui où le monde entier remplit juste la carte (le monde fait 256 x 2^zoom px).
      // En dessous, il serait plus petit que la carte et se répéterait sur les côtés.
      function computeMinZoom() {
        var size = Math.max(mapEl.clientWidth, mapEl.clientHeight);
        return size ? Math.max(0, Math.ceil(Math.log(size / 256) / Math.LN2)) : 0;
      }

      map = L.map(mapEl, {
        minZoom: computeMinZoom(),
        maxBounds: [[-85.06, -180], [85.06, 180]], // on ne peut pas glisser au-delà du monde
        maxBoundsViscosity: 1.0
      }).setView([defaultLat, defaultLng], startZoom);

      // Si la carte change de taille (rotation, redimensionnement), on recalcule ce minimum.
      map.on('resize', function () { map.setMinZoom(computeMinZoom()); });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        noWrap: true, // pas de copies du fond de carte à gauche et à droite
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>'
      }).addTo(map);
      clusterGroup = L.markerClusterGroup({
        // Par défaut, le plugin choisit la couleur d'après le nombre de magasins regroupés :
        //   moins de 10 -> classe "marker-cluster-small"  (vert)
        //   10 à 99     -> classe "marker-cluster-medium" (jaune)
        //   100 et plus -> classe "marker-cluster-large"  (orange)
        // Ici on reprend sa fonction à l'identique, mais on impose toujours "small" : tout est vert.
        iconCreateFunction: function (cluster) {
          return L.divIcon({
            html: '<div><span>' + cluster.getChildCount() + '</span></div>',
            className: 'marker-cluster marker-cluster-small',
            iconSize: L.point(40, 40)
          });
        }
      });
      // Le groupe n'est PAS ajouté à la carte ici : il l'est dans addMarkers(), une fois tous les
      // marqueurs chargés dedans (voir l'explication là-bas).
    }

    function storeUrl(store) {
      var slug = slugOverrides[store.code] || slugify(store.name);
      return baseUrl + slug;
    }

    // CUSTOM N4 : adresse texte du magasin (plus fiable que les coordonnées GPS de l'API).
    function storeAddress(store) {
      return [store.address1, store.address2, store.zip, store.city].filter(Boolean).join(' ');
    }

    // CUSTOM N4 : les 3 liens d'itinéraire. Sans adresse, on se rabat sur les coordonnées GPS.
    function directionsLinks(store) {
      var addr = storeAddress(store);
      var dest = addr || (store.lat + ',' + store.lng);
      var googleDest = addr ? store.name + ' ' + addr : dest; // le nom aide Google à trouver la fiche du magasin
      return {
        waze: 'https://waze.com/ul?q=' + encodeURIComponent(dest) + '&navigate=yes',
        google: 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(googleDest),
        apple: 'https://maps.apple.com/?daddr=' + encodeURIComponent(dest)
      };
    }

    // Lien de secours du bouton "Itinéraire" (si la modale ne peut pas s'ouvrir) : Google Maps.
    function directionsUrl(store) {
      return directionsLinks(store).google;
    }

    function linkAttrs() {
      return openNewTab ? ' target="_blank" rel="noopener"' : '';
    }

    // Certains numéros contiennent une adresse e-mail collée en base
    // (ex. "09 67 25 02 53 gradignan@fitnessboutique.fr") : on ne garde que le numéro.
    function cleanPhone(phone) {
      return String(phone || '')
        .split(/\s+/)
        .filter(function (part) { return part && part.indexOf('@') === -1; })
        .join(' ');
    }

    // Pour le lien tel: on ne garde que les chiffres et un éventuel "+" (indicatif international).
    function telHref(phone) {
      var digits = phone.replace(/[^\d+]/g, '');
      return digits ? 'tel:' + digits : '';
    }

    var PHONE_ICON = '<svg class="store-locator__phone-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>';

    // Renvoie le lien cliquable du téléphone (icône + numéro), ou '' s'il n'y a pas de numéro.
    function phoneLinkHtml(store) {
      var label = cleanPhone(store.phone);
      var href = telHref(label);
      if (!label || !href) return '';
      return '<a class="store-locator__phone" href="' + href + '">' + PHONE_ICON + '<span>' + label + '</span></a>';
    }

    // Le nom du magasin est un lien vers sa page (ce que faisait "Voir le site").
    function nameLinkHtml(store) {
      return '<a class="store-locator__item-name-link" href="' + store.url + '"' + linkAttrs() + '>' + store.name + '</a>';
    }

    // "Voir le site · Itinéraire". Sur mobile, le CSS masque "Voir le site" et le séparateur.
    // CUSTOM N4 : data-sl-dir = numéro du magasin, lu au clic pour remplir la modale d'itinéraire.
    function actionsHtml(store, linkClass) {
      var base = linkClass ? linkClass + ' ' : '';
      return '<a class="' + base + 'store-locator__link--site" href="' + store.url + '"' + linkAttrs() + '>Voir le site</a>' +
        '<span class="store-locator__sep">&middot;</span>' +
        '<a class="' + base + 'store-locator__link--directions" href="' + directionsUrl(store) + '" data-sl-dir="' + store.id + '" target="_blank" rel="noopener">Itinéraire</a>';
    }

    function popupHtml(store) {
      var lines = [];
      lines.push('<strong>' + nameLinkHtml(store) + '</strong>');
      var addr = [store.address1, store.address2].filter(Boolean).join(', ');
      if (addr) lines.push(addr);
      lines.push([store.zip, store.city].filter(Boolean).join(' '));
      var phone = phoneLinkHtml(store);
      if (phone) lines.push(phone);
      lines.push(actionsHtml(store, ''));
      return '<div class="store-locator__popup">' + lines.join('<br>') + '</div>';
    }

    function renderList(items, opts) {
      opts = opts || {};
      listEl.innerHTML = '';
      if (!items.length) {
        listEl.innerHTML = '<p class="store-locator__empty">Aucun magasin trouvé.</p>';
        return;
      }
      items.forEach(function (store) {
        var el = document.createElement('div');
        el.className = 'store-locator__item';
        var distanceHtml = (opts.showDistance && typeof store._distance === 'number')
          ? '<span class="store-locator__distance">' + store._distance.toFixed(1) + ' km</span>'
          : '';
        var addressLine = [store.address1, [store.zip, store.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
        var phone = phoneLinkHtml(store);
        var phoneBlock = phone ? '<p class="store-locator__item-phone">' + phone + '</p>' : '';
        el.innerHTML =
          '<p class="store-locator__item-name"><span class="store-locator__item-title"><svg class="store-locator__item-pin" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21s-7-6.2-7-11.2C5 6.1 8.1 3 12 3s7 3.1 7 6.8C19 14.8 12 21 12 21z" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="9.5" r="2.3" stroke="currentColor" stroke-width="1.6"/></svg>' + nameLinkHtml(store) + '</span>' + distanceHtml + '</p>' +
          '<p class="store-locator__item-address">' + addressLine + '</p>' +
          '<div class="store-locator__item-footer">' +
            phoneBlock +
            '<p class="store-locator__item-actions">' + actionsHtml(store, 'store-locator__item-link') + '</p>' +
          '</div>';
        el.addEventListener('click', function (e) {
          // closest('a') : vrai si on a cliqué sur un lien OU sur quelque chose à l'intérieur d'un lien
          // (nom, numéro de téléphone, "Itinéraire"...) : dans ce cas on laisse le lien faire son travail
          // au lieu de recentrer la carte.
          if (e.target.closest('a')) return;
          focusStore(store);
        });
        listEl.appendChild(el);
      });
    }

    function focusStore(store) {
      if (!store.marker) return;
      map.setView([store.lat, store.lng], 15);
      store.marker.openPopup();
    }

    function fetchStores() {
      setStatus('Chargement des magasins…');
      return fetch(apiUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var raw = Array.isArray(data) ? data : (data.locations || data.stores || data.results || data.data || []);
          stores = raw.map(function (item) {
            var addr = item.address || {};
            var details = item.details || {};
            var store = {
              code: item.code,
              name: details.name || item.code,
              phone: addr.phone || details.phone || details.tel || item.phone || '',
              address1: addr.address1 || '',
              address2: addr.address2 || '',
              city: addr.city || '',
              zip: addr.zip || '',
              country: addr.country_code || '',
              lat: parseFloat(addr.latitude),
              lng: parseFloat(addr.longitude)
            };
            store.url = storeUrl(store);
            return store;
          }).filter(function (s) { return !isNaN(s.lat) && !isNaN(s.lng) && !(s.lat === 0 && s.lng === 0); });

          stores.sort(function (a, b) {
            return a.city.localeCompare(b.city) || a.name.localeCompare(b.name);
          });

          // CUSTOM N4 : numéro de chaque magasin (sa place dans "stores"), pour que le lien
          // "Itinéraire" retrouve le bon magasin, même dans la liste triée par distance.
          stores.forEach(function (store, i) { store.id = i; });

          // La liste s'affiche tout de suite, sans attendre (ni dépendre de) la carte.
          renderList(stores);
          setStatus('');
        })
        .catch(function (err) {
          console.error('Store locator: erreur de chargement des magasins', err);
          setStatus('');
          listEl.innerHTML = '<p class="store-locator__error">Impossible de charger la liste des magasins pour le moment. Merci de réessayer plus tard.</p>';
        });
    }

    function geocodePostalCode(query) {
      var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=fr&postalcode=' + encodeURIComponent(query);
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('geocoding');
          return res.json();
        })
        .then(function (results) {
          if (results && results.length) {
            return { lat: parseFloat(results[0].lat), lng: parseFloat(results[0].lon) };
          }
          var fallbackUrl = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=fr&q=' + encodeURIComponent(query);
          return fetch(fallbackUrl, { headers: { 'Accept': 'application/json' } })
            .then(function (res) { if (!res.ok) throw new Error('geocoding'); return res.json(); })
            .then(function (fallbackResults) {
              if (!fallbackResults || !fallbackResults.length) throw new Error('not found');
              return { lat: parseFloat(fallbackResults[0].lat), lng: parseFloat(fallbackResults[0].lon) };
            });
        });
    }

    // Charge Leaflet et son plugin de regroupement (cluster), dans l'ordre :
    // le plugin a besoin que Leaflet soit déjà là.
    function loadLeaflet() {
      loadCss(CDN.leafletCss);
      loadCss(CDN.clusterCss1);
      loadCss(CDN.clusterCss2);
      return loadScript(CDN.leafletJs).then(function () { return loadScript(CDN.clusterJs); });
    }

    // Pose un marqueur par magasin sur la carte (uniquement si la carte existe).
    var allMarkers = [];
    var healTimer = null;

    // Filet de sécurité : un marqueur ne doit jamais être affiché EN PLUS de la bulle qui le contient.
    function findGhostMarkers() {
      var visible = clusterGroup._featureGroup.getLayers();
      var clusters = visible.filter(function (l) { return typeof l.getChildCount === 'function'; });
      var singles = visible.filter(function (l) { return typeof l.getChildCount !== 'function'; });
      return singles.filter(function (s) {
        return clusters.some(function (c) { return c.getAllChildMarkers().indexOf(s) !== -1; });
      });
    }

    function healClustersIfNeeded() {
      if (!map || !clusterGroup || !allMarkers.length) return;
      var ghosts;
      try { ghosts = findGhostMarkers(); } catch (e) { return; }
      if (!ghosts.length) return;
      console.warn('Store locator : ' + ghosts.length + ' marqueur(s) affiché(s) par-dessus leur bulle, regroupement reconstruit.');
      clusterGroup.clearLayers();
      clusterGroup.addLayers(allMarkers);
    }

    // On vérifie 600 ms après la fin de chaque zoom/déplacement (le temps que les animations finissent).
    function scheduleHeal() {
      clearTimeout(healTimer);
      healTimer = setTimeout(healClustersIfNeeded, 600);
    }

    var markersAdded = false;
    function addMarkers() {
      if (!map || !clusterGroup || markersAdded) return;
      markersAdded = true;

      // Largeur maximale de la popup : plus étroite sur mobile, où la carte ne fait qu'environ 300 px.
      var popupOptions = { maxWidth: mobileQuery.matches ? 240 : 300, autoPanPadding: [12, 12] };

      var markers = stores.map(function (store) {
        var marker = L.marker([store.lat, store.lng], { icon: pinIcon() }).bindPopup(popupHtml(store), popupOptions);
        store.marker = marker;
        return marker;
      });

      // Pourquoi en bloc, et AVANT d'ajouter le groupe à la carte ?
      // Ajouter les marqueurs un par un à un groupe déjà affiché laisse le plugin recalculer et
      // redessiner les bulles à chaque ajout. Si la carte bouge à ce moment-là (zoom, aperçu mobile
      // de l'éditeur qui se redimensionne...), certains marqueurs restent affichés EN PLUS de la
      // bulle qui les contient : des pins rouges posés sur une bulle verte, définitivement.
      // En ajoutant tout dans un groupe encore "hors carte", puis le groupe lui-même, le plugin
      // calcule tous les regroupements d'un seul coup, sans qu'aucun événement puisse s'intercaler.
      allMarkers = markers;
      clusterGroup.addLayers(markers);
      map.invalidateSize({ animate: false }); // taille réelle de la carte connue avant de calculer ce qui est visible
      map.addLayer(clusterGroup);

      map.on('zoomend moveend', scheduleHeal);
      scheduleHeal();
    }

    // Montre la position recherchée sur la carte. Ne fait rien s'il n'y a pas (encore) de carte.
    function showOriginOnMap(origin) {
      if (!map) return;
      if (userMarker) map.removeLayer(userMarker);
      userMarker = L.circleMarker([origin.lat, origin.lng], {
        radius: 7, color: '#1a73e8', weight: 2, fillColor: '#1a73e8', fillOpacity: 0.5
      }).addTo(map);
      map.setView([origin.lat, origin.lng], 11);
    }

    function applySearchOrigin(origin) {
      stores.forEach(function (store) {
        store._distance = haversine(origin.lat, origin.lng, store.lat, store.lng);
      });
      var sorted = stores.slice().sort(function (a, b) { return a._distance - b._distance; });
      renderList(sorted, { showDistance: true });

      lastOrigin = origin;
      showOriginOnMap(origin);
    }

    function handleSearch() {
      var query = (inputEl.value || '').trim();
      if (!query) return;
      setStatus('Recherche en cours…');
      geocodePostalCode(query)
        .then(function (origin) {
          setStatus('');
          applySearchOrigin(origin);
        })
        .catch(function () {
          setStatus('');
          listEl.innerHTML = '<p class="store-locator__error">Aucun résultat pour « ' + query + ' ». Vérifiez le code postal ou la ville saisie.</p>';
        });
    }

    function handleGeolocate() {
      if (!navigator.geolocation) return;
      setStatus('Localisation en cours…');
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          setStatus('');
          applySearchOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        },
        function () {
          setStatus('');
        }
      );
    }

    // La carte est visible sauf sur mobile quand l'option "Afficher la carte sur mobile" est décochée.
    function mapIsVisible() {
      return !mobileQuery.matches || showMapMobile;
    }

    // 1) La liste des magasins se charge toujours, avec ou sans carte.
    var storesLoaded = fetchStores();

    // 2) La carte ne démarre (et Leaflet n'est téléchargé) que si elle est visible, et une seule fois.
    var mapStarted = false;
    function startMapIfNeeded() {
      if (mapStarted || !mapIsVisible()) return;
      mapStarted = true;
      loadLeaflet()
        .then(function () {
          initMap();
          return storesLoaded; // on a besoin des magasins pour poser les marqueurs
        })
        .then(function () {
          addMarkers();
          if (lastOrigin) showOriginOnMap(lastOrigin);
        })
        .catch(function (err) {
          // Une carte en panne ne doit pas faire disparaître la liste (qui est déjà affichée).
          console.error('Store locator: erreur de chargement de la carte', err);
          mapEl.innerHTML = '<p class="store-locator__error">La carte n\'a pas pu être chargée.</p>';
        });
    }
    startMapIfNeeded();

    // 3) Si l'écran change de catégorie (rotation du téléphone, fenêtre redimensionnée) :
    //    on démarre la carte si elle devient visible, et on lui demande de recalculer sa taille
    //    (Leaflet ne détecte pas tout seul qu'il est passé de caché à visible).
    function onViewportChange() {
      startMapIfNeeded();
      if (map) setTimeout(function () { map.invalidateSize(); }, 0);
    }
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', onViewportChange);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(onViewportChange); // anciens Safari
    }

    // 4) CUSTOM N4 : clic sur "Itinéraire" (liste ou bulle de la carte) -> modale Waze / Google Maps / Plans.
    var dirModal = root.querySelector('.store-locator__dir-modal');

    function openDirections(store) {
      if (!dirModal || typeof dirModal.showModal !== 'function') return false; // navigateur trop ancien : lien Google Maps normal
      var links = directionsLinks(store);
      dirModal.querySelectorAll('[data-app]').forEach(function (a) { a.href = links[a.dataset.app]; });
      var nameEl = dirModal.querySelector('.y-aller-modal__store');
      if (nameEl) nameEl.textContent = store.name;
      dirModal.showModal();
      return true;
    }

    // Écoute au niveau du document, en phase de "capture" (le "true" à la fin) : on intercepte
    // le clic avant que Leaflet (bulle de la carte) ou la liste ne le traitent.
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-sl-dir]');
      if (!link || !root.contains(link)) return;
      var store = stores[parseInt(link.dataset.slDir, 10)];
      if (store && openDirections(store)) e.preventDefault();
    }, true);

    if (searchBtn) searchBtn.addEventListener('click', handleSearch);
    if (inputEl) inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handleSearch(); }
    });
    if (geoBtn) geoBtn.addEventListener('click', handleGeolocate);
  }

  document.querySelectorAll('.store-locator').forEach(initStoreLocator);
})();
